import {AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS} from 'react-admin';
import jwt from 'jsonwebtoken';

const loginUri = process.env.REACT_APP_API_ENTRYPOINT + '/login_check';
const logoutUri = process.env.REACT_APP_API_ENTRYPOINT + '/logout';
const currentUserUri = process.env.REACT_APP_API_ENTRYPOINT + '/user/current';


export default (type, params) => {
    switch (type) {
        case AUTH_LOGIN:
            localStorage.removeItem('token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('language');
            const {username, password} = params;
            const request = new Request(`${loginUri}`, {
                method: 'POST',
                body: JSON.stringify({username, password}),
                headers: new Headers({'Content-Type': 'application/json'})
            });
            return fetch(request)
                .then(response => {
                    if (response.status < 200 || response.status >= 300)
                        throw new Error(response.statusText);
                    return response.json();
                })
                .then(({token, refresh_token}) => {
                    let decodedToken = jwt.decode(token);
                    if (decodedToken.roles.length < 1) {
                        throw new Error('User is not admin');
                    }
                    localStorage.setItem('token', token); // The JWT token is stored in the browser's local storage
                    localStorage.setItem('refresh_token', refresh_token); // The JWT token is stored in the browser's local storage
                    const currentUserRequest = new Request(currentUserUri, {
                        method: 'GET',
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + token
                        })
                    });

                    return fetch(currentUserRequest)
                        .then(response => {
                            if (response.status < 200 || response.status >= 300)
                                throw new Error(response.statusText);
                            return response.json();
                        })
                        .then(({language}) => {
                            localStorage.setItem('language', language);
                            setTimeout(function () { //#TODO This avoids the login action redirecting to the login form. Find a cleaner fix
                                if (window.location.hash === '#/login') {
                                    window.location = '/';
                                }
                            }, 100);
                            return Promise.resolve();
                        });
                });

        case AUTH_LOGOUT:
            const logoutRequest = new Request(logoutUri, {
              method: 'POST',
              body: JSON.stringify({refreshToken: localStorage.getItem('refresh_token')}),
              headers: new Headers({
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + localStorage.getItem('token')
              })
            });
            fetch(logoutRequest).then(()=>{});
            localStorage.removeItem('token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('language');
            break;

        case AUTH_ERROR:
            if (params.status === 401 || params.status === 403) {
                localStorage.removeItem('token');
                localStorage.removeItem('refresh_token');
                localStorage.removeItem('language');
                return Promise.reject();
            }
            return Promise.resolve();
        case AUTH_CHECK:
            return localStorage.getItem('refresh_token')
                ? Promise.resolve()
                : Promise.reject();
        case AUTH_GET_PERMISSIONS:
            let decodedToken = jwt.decode(localStorage.getItem('token'));
            return decodedToken.roles ? Promise.resolve(decodedToken.roles) : Promise.reject();
        default:
            return Promise.resolve();
    }
};



// WEBPACK FOOTER //
// ./src/security/authProvider.js